import { createQueryStore } from '@/core/lib/utils/create-query'
import { ID } from '@/core/types/models/id.model'
import { getAirports } from '../../providers/client'
import { AirportModel } from '../../types/models/airport.model'

export const useAirports = createQueryStore<
  AirportModel[],
  { countryId?: ID; search?: string }
>(getAirports, [])
